export default __webpack_public_path__ + "static/media/mango.bd792d3a.jpg";